var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.withButtons && _vm.mediaQueries)?_c('div',{staticClass:"whatsapp-contact",class:{'whatsapp-hidden': !_vm.show}},[_c('a',{attrs:{"href":_vm.social.whatsapp}},[_c('img',{attrs:{"width":"80","height":"80","src":require("@/assets/images/whatsapp.png"),"alt":"واتساپ"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }